$(document).ready(function () {
  $('.l1').on('click', function (e) {
    e.preventDefault();
    var tag = $(this).attr('value');
    var back_link = "#" + tag;

    var elName = $('.menu--level-one' + "#" + tag);
    var menuList = $(elName);

    menuList.find('.back-link').attr('href', back_link);
    menuList.find('.back-link').attr('value', tag);

    elName.removeClass('active back');
    elName.toggleClass('active forward');
  });

  $('.l2').on('click', function (e) {
    e.preventDefault();
    var tag = $(this).attr('value');
    var back_link = "#" + tag;

    var elName = $('.menu--level-two' + "#" + tag);
    var menuList = $(elName);

    menuList.find('.back-link').attr('href', back_link);
    menuList.find('.back-link').attr('value', tag);

    elName.removeClass('active back');
    elName.toggleClass('active forward');
  });

  $('.back-link').on('click', function (e) {
    e.preventDefault();
    var tag = $(this).attr('href');
    $(tag).removeClass('active forward');
  });
});